<template>
  <div>
    <div class="compatible-heading" v-if="fullname.length > perPage">
      <div class="range">({{ range }} of {{fullname.length}})</div>
      <div>
        <input class="compatibleSearch" v-model="searchQuery" placeholder="Search compatible vehicles...">
      </div>
    </div>

    <div class="compatible-lists">
      <p v-for="(name, index) in paginatedNames" :key="index">{{ name }}</p>
      <div class="pagination" v-if="fullname.length > perPage">
        <button :disabled="currentPage === 1" @click="prevPage">Prev</button>
        <button v-for="page in pages" :key="page" @click="changePage(page)" :class="{active: currentPage === page}">{{ page }}</button>
        <button :disabled="currentPage === totalPages" @click="nextPage">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullname: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      default: 24,
    },
  },
  data() {
    return {
      currentPage: 1,
      searchQuery: "",
      range: "",
    };
  },
  mounted() {
    this.range = `1-${Math.min(this.perPage, this.fullname.length)}`;
  },
  computed: {
    totalPages() {
      return Math.ceil(this.fullname.length / this.perPage);
    },
    paginatedNames() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      const filteredNames = this.fullname.filter((name) => {
        return name.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
      if (this.searchQuery) {
        return filteredNames;
      } else {
        return filteredNames.slice(startIndex, endIndex);
      }
    },
    pages() {
      const pagesArray = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pagesArray.push(i);
      }
      return pagesArray;
    },
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
      this.searchQuery = "";
      this.range = `${(page - 1) * this.perPage + 1}-${Math.min(page * this.perPage, this.fullname.length)}`;
    },
    prevPage() {
      this.currentPage--;
      this.searchQuery = "";
      this.range = `${(this.currentPage - 1) * this.perPage + 1}-${this.currentPage * this.perPage}`;
    },
    nextPage() {
      this.currentPage++;
      this.searchQuery = "";
      this.range = `${(this.currentPage - 1) * this.perPage + 1}-${Math.min(this.currentPage * this.perPage, this.fullname.length)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.compatible-heading{
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 585px) {
      flex-direction: column;
    }

  .range{
    display: flex;
    align-items: center;
  }

  .compatibleSearch{
    width: 276px;
    padding: 10px 15px;
    margin-bottom: 10px;
    border-radius: 0;
    border: 1px solid #eaeaea;
    color: #212529;

    @media only screen and (max-width: 585px) {
      width: 100%;
    }

  }
}

.compatible-lists{
  .pagination {
    display: flex;
    justify-content: left;
    margin-top: 10px;

    @media only screen and (max-width: 767px) {
      justify-content: center;
      flex-wrap: wrap;
    }
  }

  .pagination button {
    margin: 0 5px;
    padding: 5px 10px;
    border: 1px solid #ccc;
    background: #f9f9f9;
    cursor: pointer;

    @media only screen and (max-width: 767px) {
      margin: 5px;
      padding: 5px;
    }
  }

  .pagination button.active {
    background: #ccc;
  }
}

</style>
